// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import ShopOutlined from '/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/ShopOutlined';
import UserOutlined from '/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/UserOutlined';
import CreditCardOutlined from '/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/CreditCardOutlined';
import WalletOutlined from '/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/WalletOutlined';
export default { SmileOutlined, ShopOutlined, UserOutlined, CreditCardOutlined, WalletOutlined };
